import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

const StorePage = () => {
  const { slug } = useParams();
  const [store, setStore] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    console.log("🟡 Fetching store:", slug);

    axios
      .get(`https://hrgf.salepatner.com/api/stores/${slug}/`)
      .then((res) => {
        console.log("✅ Store data:", res.data);
        setStore(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("❌ Error fetching store:", err.message);
        setError(true);
        setLoading(false);
      });
  }, [slug]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen text-gray-600 text-lg">
        Loading store details...
      </div>
    );
  }

  if (error || !store) {
    return (
      <div className="flex flex-col justify-center items-center min-h-screen text-red-600 text-lg">
        ❌ Store not found or failed to load.
        <Link to="/home" className="text-indigo-600 mt-2 underline">
          ← Go Back
        </Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 font-sans">
      <header className="bg-white shadow-md py-4 px-6 sticky top-0 z-50 flex justify-between items-center">
        <Link to="/home" className="text-indigo-600 font-semibold hover:text-indigo-800">
          ← Back
        </Link>
        <h1 className="text-2xl font-extrabold bg-gradient-to-r from-indigo-500 to-pink-500 bg-clip-text text-transparent uppercase">
          {store.name}
        </h1>
      </header>

      <section className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 mt-10 px-6">
        <div className="col-span-2 relative rounded-2xl overflow-hidden shadow-lg">
          <img src={store.banner} alt={store.name} className="w-full h-[420px] object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
          <div className="absolute bottom-8 left-8 text-white">
            <div className="bg-yellow-400 text-gray-900 font-bold px-3 py-1 rounded-full inline-block mb-2">
              SALE LIVE NOW
            </div>
            <h2 className="text-4xl font-extrabold leading-tight drop-shadow-md">
              Big Festive Dhamaka 🎉
            </h2>
            <p className="text-lg font-medium opacity-90 mt-2">50–90% Off Across Categories</p>
          </div>
        </div>

        <div className="bg-white p-6 rounded-2xl shadow-lg border border-gray-100 flex flex-col justify-between">
          <div>
            <div className="flex items-center gap-4 mb-4">
              <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center shadow-inner">
                <img src={store.logo} alt={store.name} className="w-12 h-12 object-contain rounded-full" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-gray-800">{store.name}</h2>
                <p className="text-sm text-gray-500">4.9 ★ | 1800+ Ratings</p>
              </div>
            </div>
            <p className="text-gray-600 text-sm mb-4">{store.description}</p>
            <div className="bg-orange-100 text-orange-800 text-center py-4 rounded-xl font-semibold text-lg mb-4">
              Upto {store.cashback}% Cashback
            </div>
            <a
              href={store.tracking_url || ""}
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-xl font-semibold text-center transition shadow-md"
            >
              Earn Cashback on {store.name}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default StorePage;
